// extracted by mini-css-extract-plugin
export default {"f":"_00b7691370","main":"_1604b41b06","btn":"f01c07b399","w":"_8fd45a25be","h":"_2d7823b4c9","lh25":"_6c0dd9d342","wb":"_1162cdcc75","b":"f8b839b217","bx":"fc8f0dbc41"};